/* V1.13 · Paliers du panier (snippet mp-cart-body) : ajout du cadeau mystere choisi par le client, et garde-fou apres
   chaque mise a jour du panier : un seul cadeau, en un exemplaire, et jamais sous le palier (retire tout seul sinon).
   S'appuie sur window.MPCart (assets/mp-cart.js) et son evenement mp:cart:updated. */
(function () {
  'use strict';
  if (window.__mpTiers) return;
  window.__mpTiers = true;
  var doc = document;
  var busy = false;

  function api() { return window.MPCart; }
  function done() {
    busy = false;
    setTimeout(guard, 50);
  }

  function guard() {
    if (busy || !api()) return;
    var bar = doc.querySelector('[data-mp-tiers]');
    if (!bar) return;
    var keys = (bar.getAttribute('data-gift-keys') || '').split(',').filter(Boolean);
    if (!keys.length) return;
    var ok = bar.getAttribute('data-gift-ok') === 'true';
    var qty = parseInt(bar.getAttribute('data-gift-qty'), 10) || 0;
    var todo = null;
    if (!ok) todo = [keys[0], 0];
    else if (keys.length > 1) todo = [keys[keys.length - 1], 0];
    else if (qty > 1) todo = [keys[0], 1];
    if (!todo) return;
    busy = true;
    api().change(todo[0], todo[1]).then(done, done);
  }

  doc.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-mp-gift-add]') : null;
    if (!b || !api() || busy) return;
    e.preventDefault();
    busy = true;
    b.setAttribute('aria-busy', 'true');
    api().add({ id: b.getAttribute('data-mp-gift-add'), quantity: 1, properties: { _gift: 'Cadeau mystère' } }).then(done, done);
  });
  doc.addEventListener('mp:cart:updated', function () { setTimeout(guard, 0); });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', guard);
  else guard();
})();
